(function () {
	angular
		.module('trackeye')
		.factory('SutMessageService', SutMessageService);

	SutMessageService.$inject = ["SutMessageCollection", "SutMessage", "C4ApiService", "$q"];

	function SutMessageService(SutMessageCollection, SutMessage, api, $q) {
		// @todo maybe buffers should be a class instead.
		var exports = {},
			buffer = {},
			timeouts = {},
			defaults = {
				buffer_threshhold: 20,
				max_timeout: 5, 		// Max. no. of times a recursive request is allowed to T/O
				timeframe: 12, 			// 12 hours
				max_timeframe: 24 * 7 	// 7 days
			};

		exports.newSutMessageCollection = function () {
			return new SutMessageCollection();
		};

		exports.newSutMessage = function () {
			return new SutMessage();
		};

		exports.hasTimeout = function (uuid) {
			return isTimedOut(uuid);
		};
		/**
		 * Load sutmessages for a device, from a given timestamp
		 * @param {Device} device - Device identifier
		 * @param {string} [timestamp] - ISO Timestamp to start the query from.
		 * @returns {Promise}
		 */
		exports.loadMessages = function loadMessages(device, timestamp) {
			var defer = $q.defer(),
				device_uuid = device.getUuid();

			if (hasBigEnoughBuffer(device_uuid)) {
				//_log('Shifting %d messages off the buffer for %s', defaults.buffer_threshhold, device.getNodeId());
				defer.resolve(shiftBuffer(device_uuid));
				//_log('Buffer now contains %d messages', countBuffer(device_uuid));
			} else if (countBuffer(device_uuid) > 0) {
				if (!isTimedOut(device_uuid)) {
					//_log('Loading messages for %s from last buffer entry', device.getNodeId());
					loadMessagesByLastEntry(device_uuid, defaults.timeframe, defer)
				} else {
					//_log('Previous request hit timeout. Shifting off remaining %d messages', countBuffer(device_uuid));
					defer.resolve(shiftBuffer(device_uuid));
				}
			} else if (isTimedOut(device_uuid)) {
				//_log('Previous request, hit timeout. Buffer is empty');
				defer.reject();
			} else if (timestamp) {
				//_log('Loading messages for %s by timestamp', device.getNodeId());
				loadMessagesByTimestamp(device_uuid, timestamp, defaults.timeframe, defer);
			} else {
				//_log('Could not load messages. No timestamp supplied');
				defer.reject();
			}

			return defer.promise;
		};

		/**
		 * Load new messages, using the timestamp of the last entry,
		 * in the buffer for the given uuid
		 * @param {string} uuid
		 * @param {number} timeframe
		 * @param {Deferred} defer
		 * @returns {void}
		 */
		function loadMessagesByLastEntry(uuid, timeframe, defer) {
			var message = getOldestEntryInBuffer(uuid);

			//_log('Last entry is %s', message.getTs());

			loadMessagesByTimestamp(uuid, message.getTs(), timeframe, defer);
		}

		/**
		 * Load new messages, by using the supplied arguments.
		 * @param {string} uuid
		 * @param {string} end_ts
		 * @param {number} timeframe
		 * @param {Deferred} defer
		 * @returns void
		 */
		function loadMessagesByTimestamp(uuid, end_ts, timeframe, defer) {
			if (hasBigEnoughBuffer(uuid)) {
				defer.resolve(shiftBuffer(uuid));
				//_log('Completed. Shifted off %d messages. Buffer now contains %d messages', defaults.buffer_threshhold, countBuffer(uuid));

				return;
			}

			if (isTimedOut(uuid)) {
				//_log('Timed out, after %d attempts. Shifting off %d remaing messages.', defaults.max_timeout, countBuffer(uuid));
				defer.resolve(shiftBuffer(uuid, countBuffer(uuid)));

				return;
			}

			// Make {begin_ts}, from {end_ts} subtracted with {timeframe}
			var begin_ts = subtractTimeframe(end_ts, timeframe);

			//_log('Loading messages from %s to %s', end_ts, begin_ts);
			api.sutmessages().get({
				id: uuid,
				end: end_ts,
				begin: begin_ts
			}, function (response) {
				resetTimeout(uuid);
				//_log('Got %d messages', response.length);
				appendBuffer(uuid, response);

				timeframe = calculateOptimalTimeframe(response.length, timeframe);
				if (!hasBigEnoughBuffer(uuid)) {
					//_log('Has %d need %d more to complete', countBuffer(uuid), (defaults.buffer_threshhold - countBuffer(uuid)));
					//_log('New timeframe is set to %d hours', timeframe);
				}
				loadMessagesByTimestamp(uuid, begin_ts, timeframe, defer);
			}, function () {
				//_log('No messages.');
				bumpTimeout(uuid);

				loadMessagesByTimestamp(uuid, begin_ts, defaults.max_timeframe, defer);
			});
		}

		/**
		 * Used to calculate a timeframe, when resursively querying for
		 * historical sutmessages.
		 * @param {number} lengthOfResponse - Length of the response array
		 * @param {number} currentTimeframe - Current timeframe in hours
		 * @returns {number}
		 */
		function calculateOptimalTimeframe(lengthOfResponse, currentTimeframe) {
			var messagesPerHour = lengthOfResponse / currentTimeframe,
				optimalTimeframe = Math.round(defaults.buffer_threshhold / messagesPerHour);

			return (optimalTimeframe > defaults.max_timeframe) ? defaults.max_timeframe : optimalTimeframe || 24;
		}

		/**
		 * Subtracts timeframe from ISO ts string
		 * @param {string} timestamp
		 * @param {number} timeframe
		 * @returns {string}
		 */
		function subtractTimeframe(timestamp, timeframe) {
			var ts = new Date(timestamp);

			ts = new Date(ts.setHours(ts.getHours() - timeframe));
			return ts.toISOString();
		}

		/**
		 * Bumps the timeout counter by 1
		 * @param {string} uuid
		 * @returns {number}
		 */
		function bumpTimeout(uuid) {
			if (!timeouts[uuid]) {
				timeouts[uuid] = 1;
			} else {
				timeouts[uuid]++;
			}
			//_log('Timeouts %d/%d', timeouts[uuid], defaults.max_timeout);
		}

		/**
		 * Resets timeout counter
		 * @param {string} uuid
		 */
		function resetTimeout(uuid) {
			timeouts[uuid] = 0;
		}

		/**
		 * Asserts if the timeout has exceed the threshhold.
		 * @param {string} uuid
		 * @returns {boolean}
		 */
		function isTimedOut(uuid) {
			if (!timeouts[uuid])
				timeouts[uuid] = 0;

			return timeouts[uuid] >= defaults.max_timeout;
		}

		/**
		 * Gets oldest entry of a buffer array
		 * @param {string} uuid
		 * @returns {SutMessage}
		 */
		function getOldestEntryInBuffer(uuid) {
			return buffer[uuid][countBuffer(uuid) - 1];
		}

		function sortBuffer(uuid) {
			buffer[uuid].sort(function (sut1, sut2) {
				var ts1 = sut1.getTime(),
					ts2 = sut2.getTime();

				if (ts1 > ts2) {
					return -1;
				} else if (ts1 < ts2) {
					return 1;
				}
				return 0;
			});
		}

		/**
		 * Return number of items in buffer.
		 * Will create a new buffer, if none exists
		 * @param uuid
		 * @returns {number}
		 */
		function countBuffer(uuid) {
			if (!buffer[uuid]) {
				newBuffer(uuid);
				return 0;
			}
			return buffer[uuid].length;
		}

		/**
		 * Check if a buffer is larger than, or equal to the default threshold.
		 * Will create a new buffer, if none exists
		 * @param uuid
		 * @returns {boolean}
		 */
		function hasBigEnoughBuffer(uuid) {
			if (!buffer[uuid]) {
				newBuffer(uuid);
				return false;
			}

			return buffer[uuid].length >= defaults.buffer_threshhold;
		}

		/**
		 * Appends and instantiates new items to the buffer,
		 * Will create a new buffer, if none exists
		 * @param uuid
		 * @param data
		 */
		function appendBuffer(uuid, data) {
			if (!buffer[uuid])
				newBuffer(uuid);

			var messages = data.map(function (message) {
				return new SutMessage(message);
			});

			buffer[uuid] = buffer[uuid].concat(messages);

			sortBuffer(uuid);
		}

		/**
		 * Shift elements off of the buffer.
		 * @param uuid
		 * @param amount
		 * @returns {Array}
		 */
		function shiftBuffer(uuid, amount) {
			var temp = [];

			amount = amount || defaults.buffer_threshhold;

			for (var i = 0; i < amount; i++) {
				if (!buffer[uuid].length)
					break;

				var msg = buffer[uuid].shift();
				////_log(msg.getTs());
				temp.push(msg);
			}
			return temp;
		}

		function newBuffer(uuid) {
			buffer[uuid] = [];
		}

		return exports;
	}
})();